import DocumentService from 'aurora-composition/services/documentService';
import history from 'aurora-utils/history';
import WorkflowService from 'aurora-composition/services/workflowService';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import PropertiesService from 'aurora-composition/services/propertyService';
import MusatahaService from 'aurora-composition/services/musatahaService';
import {
  CleverTapCancelApplicationDetails,
  CleverTapCancelApplicationDetailsSuccess,
  CleverTapCancelApplicationDetailsFailure,
  CleverTapGenericServiceSubmitEvent,
  CleverTapGenericServiceSubmitSuccessEvent,
  CleverTapGenericServiceSubmitFailureEvent,
  CleverTapTaskReviewApplicationAcceptEvent,
  CleverTapTaskReviewApplicationAcceptSuccessEvent,
  CleverTapTaskReviewApplicationAcceptFailureEvent,
  CleverTapTaskReviewApplicationReturnEvent,
  CleverTapTaskReviewApplicationReturnSuccessEvent,
  CleverTapTaskReviewApplicationReturnFailureEvent,
  CleverTapTaskReviewApplicationRejectEvent,
  CleverTapTaskReviewApplicationRejectSuccessEvent,
  CleverTapTaskReviewApplicationRejectFailureEvent,
  CleverTapTaskReviewApplicationTerminateEvent,
  CleverTapTaskReviewApplicationTerminateSuccessEvent,
  CleverTapTaskReviewApplicationTerminateFailureEvent,
  CleverTapTaskReviewStatusViewEvent,
  CleverTapTaskReviewApplicationEditEvent,
} from 'aurora-utils/cleverTap.eventhelper';
import * as types from './constants';
import RentPaymentService from '../../services/RentPaymentService';

export const initiateApplication = params => async dispatch => {
  try {
    dispatch({ type: types.LOADING });
    const reqvalidate = {
      applicationType: params.applicationType,
      plotId: params.elmsPropertyId,
    };
    const validation = await WorkflowService.checkValidation(reqvalidate);
    if (!isEmpty(validation?.result)) {
      history.replace('/app/services/validations', {
        ...validation?.result,
      });
    } else {
      const RentPaymentInitiate = await RentPaymentService.registerApplication(params);
      if (RentPaymentInitiate?.success) {
        dispatch({ type: types.INITIATE_RENT_PAYMENT_APPLICATION_SUCCESS });
        history.push('/app/services/rent-payment/' + RentPaymentInitiate?.result?.id);
      }
    }
  } catch (err) {
    dispatch({ type: types.ERROR, payload: err });
  }
};
export const gotoSuccessScreen = data => {
  history.replace('/app/services/rent-payment/application/success', data);
};

export const downloadDocument = payload => async dispatch => {
  try {
    dispatch({ type: types.LOADING });

    const documentPdf = await DocumentService.downloadDocument(payload);
    const file = new Blob([documentPdf], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', `${payload?.fileName || 'RENT_PAYMENT.pdf'}`);
    link.target = '_blank';

    document.body.appendChild(link);

    link.click();

    link.parentNode.removeChild(link);

    dispatch({ type: types.DOWNLOAD_DOCUMENT_RENT_PAYMENT_SUCCESS });
  } catch (error) {
    dispatch({ type: types.ERROR, payload: error });
  }
};

export const fetchProperty = plotOD => async (dispatch, getState) => {
  const state = getState().RentPaymentReducer;
  try {
    dispatch({ type: types.LOADING });
    const propertyResult = await PropertiesService.fetchProperty(plotOD);
    dispatch({
      type: types.FETCH_PROPERTY_RENT_PAYMENT_SUCCESS,
      payload: {
        ...state,
        property: propertyResult?.result,
      },
    });
  } catch (error) {
    dispatch({ type: types.ERROR, payload: error });
  }
};

export const fetchApplicationDetails = id => async dispatch => {
  try {
    dispatch({ type: types.LOADING });

    const resp = await RentPaymentService.fetchRentPaymentApplication(id);

    dispatch({
      type: types.FETCH_APPLICATION_RENT_PAYMENT_SUCCESS,
      payload: {
        application: resp.result,
        applicationId: id,
        payInAdvanceYears: resp.result?.payInAdvanceYears,
        contractDetails: resp.result?.contractDTO,
      },
    });
    return resp;
  } catch (error) {
    dispatch({ type: types.ERROR, payload: error });
    return error;
  }
};

export const discardApplication = (id, param = null, data) => async (dispatch, getState) => {
  const { application } = getState().RentPaymentReducer;
  const cleverTapPayload = {
    applicationStatus: application?.applicationDetails?.applicationStatus,
    applicationId: application?.applicationDetails?.applicationId,
    applicationNumber: application?.applicationDetails?.applicationNumber,
    applicationType: application?.applicationDetails?.applicationType,
    contractNumber: application?.mortgage?.details?.contractNumber,
    contractStartDate: application?.mortgage?.details?.startDate,
    contractEndDate: application?.mortgage?.details?.endDate,
  };
  try {
    dispatch({ type: types.LOADING });
    CleverTapCancelApplicationDetails(cleverTapPayload);

    await WorkflowService.cancelApplication(id, param);
    dispatch({ type: types.RENT_PAYMENT_CANCEL_APPLICATION_SUCCESS });
    CleverTapCancelApplicationDetailsSuccess(cleverTapPayload);
    if (isObject(data)) gotoSuccessScreen(data);
    else history.replace('/app/services?slug=sale');
  } catch (error) {
    cleverTapPayload.errorCode = error?.statusCode;
    cleverTapPayload.errorMessage = error?.data?.result?.description;
    dispatch({ type: types.ERROR, payload: error });
    CleverTapCancelApplicationDetailsFailure(cleverTapPayload);
  }
};

export const addToError = message => async dispatch => {
  dispatch({ type: types.ADD_TO_ERROR_INITITATE });

  setTimeout(() => {
    dispatch({ type: types.ERROR, payload: { statusCode: 600, message } });
  }, 200);
};
export const saveApplication = payload => async dispatch => {
  try {
    dispatch({ type: types.LOADING });
    const resp = await RentPaymentService.saveApplication(payload);

    dispatch({
      type: types.FETCH_APPLICATION_RENT_PAYMENT_SUCCESS,
      payload: {
        application: resp.result,
        applicationId: payload?.applicationId,
        payInAdvanceYears: resp.result?.payInAdvanceYears,
        contractDetails: resp.result?.contractDTO,
      },
    });
    return resp;
  } catch (error) {
    dispatch({ type: types.ERROR, payload: error });
    return error;
  }
};
export const checkoutApplication = applicationId => async (dispatch, getState) => {
  const { application } = getState().RentPaymentReducer;
  const stepName = 'REVIEW';
  const CleverTapPayloadForSumbit = {
    stepName,
    screenName: `screen_${application?.applicationType}_${stepName}_view`,
    applicationStatus: application?.applicationDetails?.applicationStatus,
    applicationId: application?.applicationId,
    applicationNumber: application?.applicationDetails?.applicationNumber,
    applicationType: application?.applicationType,
  };
  try {
    dispatch({ type: types.CHECKOUT_RENT_PAYMENT_APPLICATION });

    CleverTapGenericServiceSubmitEvent(CleverTapPayloadForSumbit);

    const resp = await RentPaymentService.checkoutApplication(applicationId);

    CleverTapGenericServiceSubmitSuccessEvent(CleverTapPayloadForSumbit);

    return resp;
  } catch (err) {
    CleverTapPayloadForSumbit.errorCode = err?.statusCode;

    CleverTapPayloadForSumbit.errorMessage = err?.data?.result?.description;

    CleverTapGenericServiceSubmitFailureEvent(CleverTapPayloadForSumbit);

    dispatch({ type: types.ERROR, payload: err });
    return err;
  }
};

export const changeWorkflowStep = step => async dispatch => {
  dispatch({ type: types.CHANGE_RENT_PAYMENT_STEP, payload: { step } });
};
export const clearError = () => dispatch => {
  dispatch({ type: types.CLEAR_RENT_PAYMENT_APPLICATION_ERROR });
};

// Post Flows
export const redirection = (application, property, url) => {
  const obj = {
    application,
    property,
  };

  history.replace({
    pathname: url,
    state: { ...obj },
  });
};
export const ApprovalWorkflow = (id, actionParams, data = '/app/services?slug=sale', type) => async dispatch => {
  const application = data?.application || {};

  const cleverTapGenericPayload = {
    screenName: 'screen_task_details_view',
    applicationStatus: application?.applicationDetails?.applicationStatus,
    applicationType: application?.applicationDetails?.applicationType,
    applicationId: application?.applicationId,
    applicationNumber: application?.applicationDetails?.applicationNumber,
    applicationStep: type, // TODO::
    progressStatus: application?.applicationDetails?.progressStatus,
    contractNo: application?.details?.contractNumber,
    contractStartDate: application?.details?.startDate,
    contractEndDate: application?.details?.endDate,
  };

  try {
    if (actionParams?.approval) {
      CleverTapTaskReviewApplicationAcceptEvent({ ...cleverTapGenericPayload });
    } else {
      CleverTapTaskReviewApplicationReturnEvent({
        ...cleverTapGenericPayload,
        returnReason: actionParams?.rejectionReason,
      });
    }
    CleverTapTaskReviewStatusViewEvent({
      applicationType: application?.applicationDetails?.applicationType,
      applicationStep: application?.applicationDetails?.applicationStatus,
    });

    dispatch({ type: types.LOADING });

    if (actionParams?.approval) {
      CleverTapTaskReviewApplicationAcceptSuccessEvent({ ...cleverTapGenericPayload });
    } else {
      CleverTapTaskReviewApplicationReturnSuccessEvent({
        ...cleverTapGenericPayload,
        returnReason: actionParams?.rejectionReason,
      });
    }

    if (data !== null) {
      if (actionParams.approval) {
        history.replace(`/app/services/transfer-offplan-bank-maker-registration/${id}`);
      } else {
        gotoSuccessScreen(data);
      }
    } else {
      history.replace(data);
    }
    dispatch({ type: types.APPROVAL_RENT_PAYMENT_SUCCESS });
  } catch (error) {
    if (actionParams?.approval) {
      CleverTapTaskReviewApplicationAcceptFailureEvent({ ...cleverTapGenericPayload });
    } else {
      CleverTapTaskReviewApplicationReturnFailureEvent({
        ...cleverTapGenericPayload,
        returnReason: actionParams?.rejectionReason,
        errorMessage: error?.message,
        errorCode: error?.statusCode,
      });
    }
    dispatch({ type: types.ERROR, payload: error });
  }
};

export const ReturnWorkflow = (
  id,
  actionParams,
  data = '/app/services?slug=sale',
  type,
  applicationReturnedTo,
) => async dispatch => {
  const req = {
    applicationId: Number(id),
    approved: actionParams.approval,
    rejectionReason: actionParams.rejection,
  };

  const application = data?.application || {};
  const cleverTapGenericPayload = {
    screenName: 'screen_task_details_view',
    applicationStatus: application?.applicationDetails?.applicationStatus,
    applicationId: application?.applicationId,
    applicationNumber: application?.applicationDetails?.applicationNumber,
    applicationStep: type, // TODO::
    progressStatus: application?.applicationDetails?.progressStatus,
    contractNo: application?.details?.contractNumber,
    contractStartDate: application?.details?.startDate,
    contractEndDate: application?.details?.endDate,
  };

  if (actionParams?.approval) {
    CleverTapTaskReviewApplicationEditEvent({ ...cleverTapGenericPayload });
  } else {
    CleverTapTaskReviewApplicationReturnEvent({
      ...cleverTapGenericPayload,
      returnReason: actionParams?.rejectionReason,
    });
  }
  CleverTapTaskReviewStatusViewEvent({
    applicationType: application?.applicationDetails?.applicationType,
    applicationStep: application?.applicationDetails?.applicationStatus,
  });

  try {
    dispatch({ type: types.LOADING });
    if (
      actionParams.approval &&
      (type === 'DEVELOPER_RETURN' ||
        type === 'BUYER_RETURN' ||
        type === 'MAKER_RETURN' ||
        (type === 'DMT_REJECT' && applicationReturnedTo !== 'BANK'))
    ) {
      history.replace('/app/services/transfer-offplan/' + id);
    } else if (type === 'CHECKER_RETURN' || (type === 'DMT_REJECT' && applicationReturnedTo === 'BANK')) {
      await RentPaymentService.bankerApproval(req);
      if (actionParams.approval) {
        history.replace(`/app/services/transfer-offplan-bank-maker-registration/${id}`);
      }
    }
    if (data !== null && !actionParams.approval) {
      CleverTapTaskReviewApplicationReturnSuccessEvent({
        ...cleverTapGenericPayload,
        returnReason: actionParams?.rejectionReason,
      });
      gotoSuccessScreen(data);
    } else {
      history.replace(data);
    }

    dispatch({ type: types.POST_RETURN_RENT_PAYMENT_SUCCESS });
  } catch (error) {
    CleverTapTaskReviewApplicationReturnFailureEvent({
      ...cleverTapGenericPayload,
      returnReason: actionParams?.rejectionReason,
      errorMessage: error?.message,
      errorCode: error?.statusCode,
    });
    dispatch({ type: types.ERROR, payload: error });
  }
};
export const AprovalCancelApplication = (
  id,
  param = null,
  data = '/app/services?slug=sale',
  type,
) => async dispatch => {
  const application = data?.application || {};
  const cleverTapGenericPayload = {
    screenName: 'screen_task_details_view',
    applicationStatus: application?.applicationDetails?.applicationStatus,
    applicationId: application?.applicationId,
    applicationNumber: application?.applicationDetails?.applicationNumber,
    applicationStep: type, // TODO::
    progressStatus: application?.applicationDetails?.progressStatus,
    contractNo: application?.details?.contractNumber,
    contractStartDate: application?.details?.startDate,
    contractEndDate: application?.details?.endDate,
  };
  try {
    if (param?.status === 'REJECT') {
      CleverTapTaskReviewApplicationRejectEvent({ ...cleverTapGenericPayload });
    } else {
      CleverTapTaskReviewApplicationTerminateEvent({ ...cleverTapGenericPayload });
    }
    CleverTapTaskReviewStatusViewEvent({
      applicationType: application?.applicationDetails?.applicationType,
      applicationStep: application?.applicationDetails?.applicationStatus,
    });
    dispatch({ type: types.LOADING });
    await WorkflowService.cancelApplication(id, param);
    if (param?.status === 'REJECT') {
      CleverTapTaskReviewApplicationRejectSuccessEvent({ ...cleverTapGenericPayload });
    } else {
      CleverTapTaskReviewApplicationTerminateSuccessEvent({ ...cleverTapGenericPayload });
    }
    dispatch({ type: types.RENT_PAYMENT_CANCEL_APPLICATION_SUCCESS });
    if (data !== null) {
      gotoSuccessScreen(data);
    } else {
      history.replace('/app/applications');
    }
  } catch (error) {
    if (param?.status === 'REJECT') {
      CleverTapTaskReviewApplicationRejectFailureEvent({
        ...cleverTapGenericPayload,
        errorMessage: error?.message,
        errorCode: error?.statusCode,
      });
    } else {
      CleverTapTaskReviewApplicationTerminateFailureEvent({
        ...cleverTapGenericPayload,
        errorMessage: error?.message,
        errorCode: error?.statusCode,
      });
    }
    dispatch({ type: types.ERROR, payload: error });
  }
};
export const RentPaymentPaymentBreakdown = (application, id) => async (dispatch, getState) => {
  const state = getState().RentPaymentReducer;
  try {
    dispatch({ type: types.LOADING });
    const data = await RentPaymentService.PaymentBreakDown(application, id);
    dispatch({
      type: types.RENT_PAYMENT_PAYMENT_BREAKDOWN_SUCCESS,
      payload: { ...state, breakdown: data?.result },
    });
    return data;
  } catch (error) {
    dispatch({ type: types.ERROR, payload: error });
    return error;
  }
};

export const payInAdvancedYears = years => dispatch => {
  dispatch({ type: types.PAY_IN_ADVANCE_YEARS, payload: years });
};

export const getCurrentPropertyDocument = params => dispatch => {
  dispatch({ type: types.LOADING });

  MusatahaService.getPropertyDocuments(params)
    .then(result => {
      dispatch({ type: types.RENT_PAYMENT_PROPERTY_DOCUMENTS_SUCCESS, payload: result.result });
    })
    .catch(err => {
      dispatch({ type: types.ERROR, payload: err });
    });
};
